export class Prestador {
    static idCfc = '22CAE56C-FB05-4B5A-93A9-104D8F5234A8';
    static idClinica = 'D2B96EDE-A99C-430C-84FC-7E9DD0E4D121';
}



// WEBPACK FOOTER //
// ./src/app/models/prestador.ts